// extracted by mini-css-extract-plugin
module.exports = {"visible":"Printable_visible__MzE-g","scrollable":"Printable_scrollable__OYA33","content":"Printable_content__11ckt"};